const translationObject = {
  title: 'Thumbnail | Thumbnails',
  placeholder: 'Select thumbnail',
} as const;

export default translationObject;
